import { ProductTransfer } from './ProductTransfer';
import { User } from './User';
import { PensionProduct } from './PensionProduct';
import { File } from './File';
import { Client } from './Client';
import { ClientFile } from './ClientFile';

export enum SignatureStatus {
    Initial = 'initial',
    ClientSigned = 'clientSigned',
    RepSigned = 'repSigned',
    SpouseSigned = 'spouseSigned',
    ActiveAgentFinished = 'activeAgentFinished',
}

export enum DocumentType {
    TransferFund = 'transferFund',
    TransferMultipleProducts = 'transferMultipleProducts',
    ClientHanmaka = 'clientHanmaka',
    PowerOfAttorney = 'powerOfAttorney',
    PowerOfAttorneyMislaka = 'powerOfAttorneyMislaka',
    PowerOfAttorneyTax = 'powerOfAttorneyTax',
    PowerOfAttorneyInsurance = 'powerOfAttorneyInsurance',
    PowerOfAttorneyInsuranceSpouse = 'powerOfAttorneyInsuranceSpouse',
    TaxDeclaration = 'taxDeclaration',
    B2Form = 'b2Form',
    HaltPayments = 'haltPayments',
    PowerOfAttorneyInsuranceMountain = 'powerOfAttorneyInsuranceMountain',
    MortgageAdvisoryAgreement = 'mortgageAdvisoryAgreement',
    AgentAppointmentInsurance = 'agentAppointmentInsurance',
    AgentAppointmentInsuranceSpouse = 'agentAppointmentInsuranceSpouse',
    Insurance = 'insurance',
    InsuranceQuestionnaire = 'insuranceQuestionnaire',
    InsuranceSpouse = 'insuranceSpouse',
}

export interface SignedDocument {
    _id: string;
    createdAt: string;
    client: Client;
    rep: User;
    file: ClientFile;
    files: ClientFile[];
    clientSignedDate: Date;
    agentSignedDate: Date;
    signedFile: string;
    requestSignId: string;
    clientInvitationId: String;
    agentInvitationId: String;
    spouseInvitationId: String;
    activeAgentInvitationId: String;
    clientSigningLink: string;
    agentSigningLink: string;
    spouseSigningLink: string;
    activeAgentSigningLink: string;
    completedFormLink: string;
    documentType: DocumentType;
    signatureStatus: SignatureStatus;
    ref: {
        productTransfer: ProductTransfer;
        productTransfers: ProductTransfer[];
        product: PensionProduct;
    };
}
